import type { DefaultOptions } from '@tanstack/react-query';
import { QueryClient } from '@tanstack/react-query';

let queryClient: QueryClient | null = null;

export const setupQueryClient = (defaultOptions: DefaultOptions) => {
  queryClient = new QueryClient({
    defaultOptions,
  });
};

export const getQueryClient = () => {
  if (!queryClient) throw new Error('Query client is not set');
  return queryClient;
};
